export default function Logo({ className = "w-9 h-9" }) {
  return (
    <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
      <circle cx="20" cy="20" r="18.5" stroke="#2D6A4F" strokeWidth="1.5" />
      <path
        d="M20 7C27 12 29 19 20 31C11 19 13 12 20 7Z"
        stroke="#52B788"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="rgba(82,183,136,0.12)"
      />
      <path d="M20 12V26" stroke="#52B788" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="20" cy="20" r="1.6" fill="#D4A373" />
    </svg>
  );
}
